import { useDispatch } from 'react-redux';
import { setCommonDialog } from 'Actions/LoadingActions';
import { useCallback } from 'react';

export const usePopup = () => {
  const dispatch = useDispatch();

  const showDialog = useCallback(
    ({ title, needIntl = true, imageType = 'ex', onClose = () => {}, cancelText = 'button.close', isReverse = false, isBigPadding = false, onConfirm = null, ...rest }) => {
      dispatch(setCommonDialog({ title, needIntl, imageType, onClose, cancelText, isReverse, isBigPadding, onConfirm, ...rest }));
    },
    [dispatch]
  );

  const showOneButtonExclamationDialog = useCallback(
    ({ title, needIntl = true, onClose = () => {} }) => {
      showDialog({ title, needIntl, imageType: 'ex', onClose, cancelText: 'button.close' });
    },
    [showDialog]
  );

  const showOneButtonSuccessDialog = useCallback(
    ({ title, needIntl = true, onClose = () => {} }) => {
      showDialog({ title, needIntl, imageType: 'su', onClose, cancelText: 'button.close' });
    },
    [showDialog]
  );

  return { showOneButtonExclamationDialog, showOneButtonSuccessDialog, showDialog };
};
